var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPdfIcon28 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#svg-public/img/icons/vkui/pdf_icon_28.svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 10.2C0 6.7 0 5 .7 3.5A6.4 6.4 0 0 1 3.5.7C4.9 0 6.7 0 10.2 0h7.6c3.5 0 5.3 0 6.7.7 1.2.6 2.2 1.6 2.8 2.8.7 1.4.7 3.2.7 6.7v7.6c0 3.5 0 5.3-.7 6.7a6.4 6.4 0 0 1-2.8 2.8c-1.4.7-3.2.7-6.7.7h-7.6c-3.5 0-5.3 0-6.7-.7a6.4 6.4 0 0 1-2.8-2.8C0 23.1 0 21.3 0 17.8v-7.6Z",
  fill: "#FBCECE"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.7 10.4v7.1h1.4v-2.2h1.1c.5 0 1 0 1.4-.3.4-.2.7-.5 1-.9.2-.3.3-.8.3-1.2a2.3 2.3 0 0 0-1.3-2.1 3 3 0 0 0-1.4-.4H4.7Zm3.4 3.3c-.2.3-.5.4-.9.4h-1v-2.4h1c.4 0 .7.1 1 .3.2.2.3.5.3.9 0 .3-.1.6-.4.8ZM11.2 17.5v-7h2.7a4 4 0 0 1 2 .4c.5.3 1 .7 1.2 1.3.4.5.5 1 .5 1.8 0 .7-.1 1.3-.5 1.8-.3.5-.7 1-1.3 1.3a4 4 0 0 1-1.9.4h-2.7Zm2.7-1.3c.5 0 .8 0 1.2-.3.3-.2.6-.4.8-.8a2.4 2.4 0 0 0 0-2.3 2 2 0 0 0-.8-.8c-.4-.2-.7-.3-1.2-.3h-1.3v4.5h1.3Z",
  fill: "#A8282B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.4 17.5H19v-7h4.6v1.2h-3.2v1.8h2.9v1.3h-2.9v2.7Z",
  fill: "#A8282B"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "svg-public/img/icons/vkui/pdf_icon_28.svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h28v28H0z"
})))));
export { SvgPdfIcon28 as ReactComponent };